// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__uaxB1","ranges":"BmiRanges_ranges__4iDeG"};